import React from 'react';
import {Col, Form, Row} from "antd";
import {t, Trans} from "@lingui/macro";
import ToggleToEdit from "../../ToggleToEdit";
import { Select } from '../../DataEntry';

const { Option } = Select;

export function InventorySystemFormItem(props) {
    const { size, keepOpenAfterToggle, onToggleOpen } = props;

    const renderNotToggled = toggleOpen => (
        <Row type="flex">
            <Col span={24} style={{fontSize: 13}}>
                <Trans>
                    {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                    Inventory system is set to <strong>Perpetual</strong>.
                </Trans>
                &nbsp;
                <span
                    className="link"
                    onClick={() => {
                        toggleOpen();
                    }}
                >
                    <Trans>Change</Trans>
                </span>
                <Form.Item name="inventory_system" initialValue="perpetual" noStyle>
                    <span />
                </Form.Item>
            </Col>
        </Row>
    );

    const formItem = (
        <Row type="flex">
            <Col span={24}>
                <Form.Item
                    name="inventory_system"
                    label={t`Inventory System`}
                    rules={[{
                        required: true,
                        message: t`Inventory system is required.`,
                    }]}
                    initialValue="perpetual"
                >
                    <Select
                        placeholder={t`Select Inventory System`}
                        dropdownMatchSelectWidth={false}
                        allowClear={false}
                        showSearch
                        filterOption
                        optionFilterProp="label"
                        popupContainerId="parentElement"
                        size={size || 'medium'}
                    >
                        <Option value="perpetual" key="perpetual"><Trans>Perpetual</Trans></Option>
                        <Option value="periodic" key="periodic"><Trans>Periodic</Trans></Option>
                    </Select>
                </Form.Item>
            </Col>
        </Row>
    );

    // used in partner create client modal, to keep the form item in edit mode
    if (keepOpenAfterToggle)
        return formItem;

    return (
        <ToggleToEdit renderNotToggled={renderNotToggled} onToggleOpen={onToggleOpen}>
            {formItem}
        </ToggleToEdit>
    );
}
